import React from "react";
import { FaTwitter, FaFacebook, FaLinkedin, FaLink } from "react-icons/fa";

export default function SocialShareButtons({ article, className = "" }) {
  const shareUrl = `https://actadiurna.org.uk/article/${article.slug}`;
  const title = article.title;
  
  const shareToTwitter = () => {
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(shareUrl)}`;
    window.open(url, "_blank");
  };
  
  const shareToFacebook = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
    window.open(url, "_blank");
  };
  
  const shareToLinkedIn = () => {
    const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
    window.open(url, "_blank");
  };
  
  const copyLink = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      // Could add a toast notification here
      alert("Link copied to clipboard!");
    });
  };
  
  return (
    <div className={`flex space-x-3 ${className}`}>
      <button 
        onClick={shareToTwitter}
        className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-700"
        aria-label="Share on Twitter"
      >
        <FaTwitter />
      </button>
      <button 
        onClick={shareToFacebook}
        className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-700"
        aria-label="Share on Facebook"
      >
        <FaFacebook />
      </button>
      <button 
        onClick={shareToLinkedIn}
        className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-700"
        aria-label="Share on LinkedIn"
      >
        <FaLinkedin />
      </button>
      <button 
        onClick={copyLink}
        className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-700"
        aria-label="Copy link"
      >
        <FaLink />
      </button>
    </div>
  );
}